import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClienteFilterModule } from '../cliente-filter.module';

import { ClienteFilterModalComponent } from './cliente-filter-modal.component';


@NgModule({
    imports: [
        SharedModule,
        ClienteFilterModule
    ],
    declarations: [
        ClienteFilterModalComponent
    ],
    exports: [
        ClienteFilterModalComponent
    ]
})
export class ClienteFilterModalModule { }
